module.exports = __webpack_public_path__ + "img/bingo_line_last_call-01.4253a686.png";